import React from "react"

import {LexicalEditor} from "lexical"
import PopupMenuButton from "../../../../../../popover-menu/popup-menu-button/popup-menu-button"
import ToolbarColorButton from "./color-selector-button"
import ToolbarColorMenu from "./menu/color-selector-menu"
import {BadgeType} from "../../../../highlight/badge/badge-plugin"
import {FontColorType} from "../../../../highlight/font-color/font-color-plugin"
import IconFontComponent from "./icon-font-color"
import IconBGComponent from "./icon-bg-color"
import {PopoverMenuItemType} from "../../../../../../popover-menu/popover-menu/const"
import {PopoverAttachmentType} from "../../../../../../gd-popover/@const"

type Props = {
    editor          : LexicalEditor
    fontColorType?  : FontColorType | null
    badgeType?      : BadgeType | null
}

export default function ColorToolbarSelector(props: Props): JSX.Element {

    const iconFontComponent = (colorStyleType: any) => <IconFontComponent colorStyleType={colorStyleType}/>
    const iconBGComponent   = (colorStyleType: any) => <IconBGComponent colorStyleType={colorStyleType}/>

    const clearColorOptions = [
        {value: null,                       iconComponent: iconFontComponent(null),                     label: 'Reset Color'},
        {type: PopoverMenuItemType.SEPARATOR}
    ]

    const fontColorOptions = [
        {type: PopoverMenuItemType.HEADER, title:'Font color'},
        {value: FontColorType.LIGHT_BLUE,   iconComponent: iconFontComponent(FontColorType.LIGHT_BLUE), label: 'Light blue'},
        {value: FontColorType.DARK_BLUE,    iconComponent: iconFontComponent(FontColorType.DARK_BLUE),  label: 'Dark blue'},
        {value: FontColorType.GREEN,        iconComponent: iconFontComponent(FontColorType.GREEN),      label: 'Green'},
        {value: FontColorType.YELLOW,       iconComponent: iconFontComponent(FontColorType.YELLOW),     label: 'Yellow'},
        {value: FontColorType.ORANGE,       iconComponent: iconFontComponent(FontColorType.ORANGE),     label: 'Orange'},
        {value: FontColorType.RED,          iconComponent: iconFontComponent(FontColorType.RED),        label: 'Red'},
        {value: FontColorType.MAGENTA,      iconComponent: iconFontComponent(FontColorType.MAGENTA),    label: 'Magenta'},
        {value: FontColorType.PURPLE,       iconComponent: iconFontComponent(FontColorType.PURPLE),     label: 'Purple'},
        {value: FontColorType.BROWN,        iconComponent: iconFontComponent(FontColorType.BROWN),      label: 'Brown'},
        {value: FontColorType.GRAY,         iconComponent: iconFontComponent(FontColorType.GRAY),       label: 'Gray'},
    ]
    _.some(fontColorOptions, (option: Option)=>{
        if (option.value === props.fontColorType) {
            option.isSelected = true
            return true
        }
    })

    const badgeColorOptions = [
        {type: PopoverMenuItemType.HEADER, title:'Badge color'},
        {value: BadgeType.LIGHT_BLUE,   iconComponent: iconBGComponent(BadgeType.LIGHT_BLUE),   label: 'Light blue'},
        {value: BadgeType.DARK_BLUE,    iconComponent: iconBGComponent(BadgeType.DARK_BLUE),    label: 'Dark blue'},
        {value: BadgeType.GREEN,        iconComponent: iconBGComponent(BadgeType.GREEN),        label: 'Green'},
        {value: BadgeType.YELLOW,       iconComponent: iconBGComponent(BadgeType.YELLOW),       label: 'Yellow'},
        {value: BadgeType.ORANGE,       iconComponent: iconBGComponent(BadgeType.ORANGE),       label: 'Orange'},
        {value: BadgeType.RED,          iconComponent: iconBGComponent(BadgeType.RED),          label: 'Red'},
        {value: BadgeType.MAGENTA,      iconComponent: iconBGComponent(BadgeType.MAGENTA),      label: 'Magenta'},
        {value: BadgeType.PURPLE,       iconComponent: iconBGComponent(BadgeType.PURPLE),       label: 'Purple'},
        {value: BadgeType.BROWN,        iconComponent: iconBGComponent(BadgeType.BROWN),        label: 'Brown'},
        {value: BadgeType.GRAY,         iconComponent: iconBGComponent(BadgeType.GRAY),         label: 'Gray'},
    ]

    _.some(badgeColorOptions, (option: Option)=>{
        if (option.value === props.badgeType) {
            option.isSelected = true
            return true
        }
    })

    return (
        <PopupMenuButton hint               = "Select style"
                         btnComponent       = {ToolbarColorButton}
                         attachment         = "bottom left"
                         targetAttachment   = "top left"
                         offset             = "0 6"
                         attachmentType     = {PopoverAttachmentType.HORIZONTAL}
                         menuComponent      = {ToolbarColorMenu}
                         menuParams         = {{
                             clearColorOptions  : clearColorOptions,
                             fontColorOptions   : fontColorOptions,
                             badgeColorOptions  : badgeColorOptions,

                             editor             : props.editor,
                             fontColorType      : props.fontColorType,
                             badgeType          : props.badgeType
                         }}/>
    )
}